import { ROUTE_PATHS } from "src/utils/constants";
// import { ReactComponent as ResellLogoWSXL } from "../../assets/icons/ws-zara-resell-logo-xl.svg";
// import { ReactComponent as ResellLogoWS } from "../../assets/icons/ws-zara-resell-logo.svg";

import { ReactComponent as ResellLogoWSXL } from "src/assets/icons/wsxl-zara-pre-owned-new-logo.svg";
import { ReactComponent as ResellLogoWS } from "src/assets/icons/ws-zara-pre-owned-new-logo.svg";
import { ReactComponent as ResellNewZdsLogoW3XL } from "src/assets/icons/zara-resell-newzds-logo-w3xl.svg";
import { ReactComponent as ResellNewZdsLogo } from "src/assets/icons/zara-resell-newzds-logo.svg";
import { FC, SVGProps } from "react";


export interface HeaderProps {
  wrapperProps: {
    whiteBackGround: boolean;
    showBackIcon: () => boolean;
    handleBackClick: () => void;
    handleDimissClick: () => void;
    onLogoClickHandled: () => void;
  };
}
export interface MatchedHandler {
  match: (path: any) => boolean;
  action: () => void;
}

const routesToCheck = [
  ROUTE_PATHS.CART,
  ROUTE_PATHS.PAYMENT_CONFIRMATION,
  ROUTE_PATHS.CHECKOUT,
];

export const isZaraHeader = (pathname: string) => {
  return routesToCheck.some((route) => pathname.includes(route));
};

const routesNotIcons = [
  ROUTE_PATHS.CART,
  ROUTE_PATHS.PAYMENT_CONFIRMATION,
  ROUTE_PATHS.CHECKOUT,
];

export const showIconInHeader = (pathname: string) => {
  return routesNotIcons.some((route) => pathname.includes(route));
};

const logoMap = {
    zara: {
      true: ResellNewZdsLogoW3XL,
      false: ResellNewZdsLogo,
    },
    preowned: {
      true: ResellLogoWSXL,
      false: ResellLogoWS,
    },
};

export const getLogoComponent = (type, viewport): FC<SVGProps<SVGSVGElement>> => {
    return (type === "zara" ? logoMap.zara : logoMap.preowned)[viewport]
};
